import { styled } from 'styled-components';

export const UploadButton = styled.div<{ disabled?: boolean }>`
  width: 48px;
  height: 48px;
  background: ${({ theme, disabled }) => (disabled ? theme.colors.grey05_1 : theme.colors.mainLight)};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropAreaCard = styled.div`
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.grey00_1};
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 12px;
`;

export const DropAreaTarget = styled.div<{ disabled?: boolean; $minHeight: string }>`
  min-height: ${({ $minHeight }) => $minHeight};
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  position: relative;

  & > svg {
    transition:
      width ease-out 0.1s,
      height ease-out 0.1s;
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
    &:hover {
      cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'default')};
    }
    & > rect {
      stroke: ${({ theme }) => theme.colors.grey30_1};
      fill: ${({ theme }) => theme.colors.grey01_1};
      fill-opacity: ${({ disabled }) => (disabled ? 1 : 0)};
      transition: fill-opacity ease-out 0.1s;
    }
  }

  & > :not(svg) {
    z-index: 1;
  }

  &[data-dragover='true'] {
    & > svg {
      width: 101%;
      height: 105%;
      & > rect {
        stroke: ${({ theme }) => theme.colors.main};
        fill-opacity: 1;
      }
    }
  }
`;

export const DropDescription = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 4px;
  padding: 0 24px;
`;
